import {Component, OnInit, Renderer2} from '@angular/core';
import {LotteriesService} from '../../../lotteries.service';
import {Router} from '@angular/router';


@Component({
  selector: 'app-free-spin-button',
  templateUrl: './free-spin-button.component.html',
  styleUrls: ['./free-spin-button.component.scss']
})
export class FreeSpinButtonComponent implements OnInit {
  closingFreeSpins: boolean;
  inited: boolean;

  constructor(public lotteryService: LotteriesService,
              private renderer: Renderer2,
              private router: Router) {
  }

  ngOnInit() {
    this.closingFreeSpins = false;
      this.renderer.addClass(document.body, 'freeSpins');
    setTimeout(() => {
      this.inited = true;
    }, 1000);
  }

  scrollToFreeSpins() {
    const el = document.getElementById('freespins');
    let scrollTo;
    if (this.lotteryService.isMobile || this.lotteryService.isTablet) {
      if (this.closingFreeSpins) {
        scrollTo = (window.pageYOffset + el.getBoundingClientRect().top) - 49;
      } else {
        scrollTo = (window.pageYOffset + el.getBoundingClientRect().top) - 110;
      }
    } else {
      scrollTo = (window.pageYOffset + el.getBoundingClientRect().top) - 70;
    }
    window.scroll({top: scrollTo, behavior: 'smooth'});
  }

  freeSpinsClick() {
    if (this.router.url.includes('casino')) {
      this.scrollToFreeSpins();
    } else {
      const lang = localStorage.getItem('pageLanguage');
      this.router.navigate([`/${lang}/casino`], {fragment: 'freespins'});
    }
  }

  closeFreeSpins() {
    this.closingFreeSpins = true;
    this.renderer.removeClass(document.body, 'freeSpins');
  }
}
